<template>
    <header class="header rel">
        <quick-launcher-bar></quick-launcher-bar>
        <navbar></navbar>
    </header>
</template>
<script>
    import Navbar from './Navbar'
    import QuickLauncherBar from './QuickLauncherBar'

    export default {
        components: {
            Navbar,
            QuickLauncherBar
        }
    }
</script>